import { useParams } from 'react-router-dom';
import Refund from 'components/ArticleOffer/offer/ArticleStatus/Refund';

import AfterCopyrightDecisionForm from './AfterCopyrightDecisionForm';
function RejectDecision() {
  const { offerID, committee, step, status } = useParams();
  return (
    <AfterCopyrightDecisionForm
      offerID={offerID}
      committee={committee}
      status={status}
    >
      <Refund
        step={step}
        status={status}
        committee={committee}
      />
    </AfterCopyrightDecisionForm>
  );
}
export default RejectDecision;
